export const MIXPANEL_EVENT_NAME_FOCUS = 'Search Bar - Focused';
